import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [MatProgressBarModule],
  exports: [MatProgressBarModule]
})
export class TiimeProgressBarModule {}
